import { TableV2 } from '@medeloop/medeloop-components-library';
import { useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useGetStudyParticipants } from 'src/api/studies-queries';
import { StudyParticipant } from 'src/types/studies';

export function ParticipantsTable() {
  const [searchTerm, setSearchTerm] = useState<string>('');
  const { studyId } = useParams();

  const { data, isLoading } = useGetStudyParticipants(studyId ?? '');

  const participants = useMemo(() => data?.participants ?? [], [data]);

  const headers = [
    { label: 'First name', key: 'firstName' },
    { label: 'Last name', key: 'lastName' },
    { label: 'Joined on', key: 'joinedOn' },
    // TODO: add email and phone number, but this is not stored in the study participants schema
  ];

  const transformedData = useMemo(
    () =>
      participants
        .filter(
          (participant: StudyParticipant) =>
            participant.givenName.toLowerCase().includes(searchTerm.toLowerCase()) ||
            participant.familyName.toLowerCase().includes(searchTerm.toLowerCase()),
        )
        .map((participant: StudyParticipant) => ({
          id: participant.participantId,
          firstName: participant.givenName,
          lastName: participant.familyName,
          joinedOn: participant.createdAt.split('T')[0], // display date in format YYYY-MM-DD
        })) ?? [],
    [participants, searchTerm],
  );

  return (
    <section className="flex flex-col w-full mt-12 border border-stroke-on-dark-subdued rounded-lg bg-background-dark-subdued px-4 py-6">
      <TableV2
        headers={headers}
        data={transformedData}
        searchPlaceholder="Search by name or email"
        onSearch={(t) => setSearchTerm(t)}
        isLoading={isLoading}
      />
    </section>
  );
}
